/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-southeast-2",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://9ft8hellp2.execute-api.ap-southeast-2.amazonaws.com/dev",
            "region": "ap-southeast-2"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://ukamxghvkff2pkhxt4cue33vtq.appsync-api.ap-southeast-2.amazonaws.com/graphql",
    "aws_appsync_region": "ap-southeast-2",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-al76tgdadrfchcrbxg7y6jmisi",
    "aws_cognito_identity_pool_id": "ap-southeast-2:7fb3b934-195e-48b6-a661-212a66105ecb",
    "aws_cognito_region": "ap-southeast-2",
    "aws_user_pools_id": "ap-southeast-2_J4gOHLg3j",
    "aws_user_pools_web_client_id": "2p3nnmsrj35ei7odjvelvdlhdt",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "cavedbffc1d9b3067746e6b464d5bad946cbf7152443-dev",
    "aws_user_files_s3_bucket_region": "ap-southeast-2",
    "geo": {
        "amazon_location_service": {
            "region": "ap-southeast-2",
            "search_indices": {
                "items": [
                    "placeIndex574fb93c-dev"
                ],
                "default": "placeIndex574fb93c-dev"
            }
        }
    }
};


export default awsmobile;
